import { Reveal, SectionHeading } from "../components/primitives";
import { PageHero, CTASection, BookButtons, Icon } from "../components/sections";
import { WHY_DWC, IMAGES, STATS } from "../data/site";
import { CountUp } from "../components/primitives";

const WhyDwc = () => (
  <>
    <PageHero
      eyebrow="Why DWC"
      lines={["Not An Ordinary", "Driving School."]}
      text="DWC is a driving confidence institute. We combine practical, real-road driving training with driving psychology — because the biggest problem in driving is rarely the car."
      image={IMAGES.dwcTraining}
      imageAlt="DWC trainer guiding a learner driver during training in Mumbai, Surat & Ahmedabad"
    >
      <BookButtons bookTestId="why-book-btn" waTestId="why-whatsapp-btn" />
    </PageHero>

    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="The DWC Philosophy"
          number="01"
          title="Driving Is A Mental Skill As Much As A Physical One"
          text="Most people learn to operate a car within days. What takes longer is staying calm in traffic, making quick decisions, and trusting yourself while driving. DWC trains both — your hands and feet, and your mind."
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_DWC.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 0.08} className="h-full">
              <article className="h-full rounded-2xl border border-gray-100 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgb(23,107,58,0.10)]">
                <span className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${f.accent ? "bg-dwc-crimson/10 text-dwc-crimson" : "bg-dwc-soft text-dwc-green"}`}>
                  <Icon name={f.icon} className="h-5 w-5" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-dwc-charcoal">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-dwc-charcoal/65">{f.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-dwc-soft py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <img src={IMAGES.dwcSession} alt="Driving training session on real city roads" loading="lazy" className="aspect-[4/3] w-full rounded-[2rem] object-cover shadow-[0_24px_60px_rgb(23,107,58,0.15)]" />
          </Reveal>
          <div>
            <SectionHeading
              eyebrow="Experience & Results"
              number="02"
              title="14+ Years. 10,288+ Confident Drivers."
              text="DWC's methods have been refined over 14+ years of real-road training in Mumbai, Surat & Ahmedabad — with beginners, nervous licence holders, women learners, senior citizens and advanced drivers."
            />
            <div className="mt-8 grid grid-cols-2 gap-6">
              {STATS.map((s, i) => (
                <div key={s.label} className="rounded-2xl border border-dwc-green/10 bg-white p-6">
                  <p className="text-3xl font-black tracking-tight text-dwc-green">
                    <CountUp value={s.value} suffix={s.suffix} testId={`why-stat-${i}`} />
                  </p>
                  <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-dwc-charcoal/60">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-dwc-soft py-20 md:py-24" data-testid="vision-mission-section">
      <div className="mx-auto grid max-w-7xl gap-6 px-5 md:grid-cols-2 lg:px-8">
        <article className="rounded-[2rem] border border-dwc-green/15 bg-white p-8 md:p-10">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-dwc-crimson">Our Vision</p>
          <h2 className="mt-3 text-2xl font-extrabold tracking-tight text-dwc-charcoal">Building Confident Drivers For Life.</h2>
          <p className="mt-3 text-sm leading-relaxed text-dwc-charcoal/70">A world where every learner goes beyond operating a vehicle — driving independently, safely and with complete confidence on every road.</p>
        </article>
        <article className="rounded-[2rem] bg-dwc-green p-8 text-white md:p-10 grain">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-emerald-200">Our Mission</p>
          <h2 className="mt-3 text-2xl font-extrabold tracking-tight">High-Quality Driving Learning For Every Learner.</h2>
          <p className="mt-3 text-sm leading-relaxed text-white/80">To provide structured, personalized, high-quality driving training that develops real driving skill, road awareness, a calm driving mindset and lasting driving confidence.</p>
        </article>
      </div>
    </section>

    <CTASection title="Experience The DWC Difference." sub="Book an appointment and we will understand exactly what stands between you and confident, independent driving." chapter="04" />
  </>
);

export default WhyDwc;
